'use es6';

import { createRequestAction } from '../request/create-request-action';
import { FETCH } from '../request/request-type';
import { getAllUser } from 'dashboard-lib/public/users/user-dao';
export const namespace = 'users';
export const fetchUsers = createRequestAction(`${namespace}_${FETCH}`, getAllUser);
export const fetchUsersActions = fetchUsers.actions;